module.exports = __webpack_public_path__ + "static/img/3d.6929eda4.svg";